import * as React from 'react';
import { storyblokEditable, StoryblokRichText, type SbBlokData } from '@storyblok/react';

import type { RichTextStoryblok } from '../../types/storyblok';
import { SiteContainer } from '../layout/SiteContainer';

interface RichTextProps {
  blok: RichTextStoryblok;
}

// Renders Storyblok rich-text content via the SDK's StoryblokRichText component.
// Visual treatment is provisional pending designer drill-down on long-form prose.
export const RichText: React.FC<RichTextProps> = ({ blok }) => (
  <article
    {...storyblokEditable(blok as unknown as SbBlokData)}
    className="text-body1 text-neutral-navy py-8"
  >
    <SiteContainer>
      {blok.content && (
        <StoryblokRichText
          doc={blok.content as unknown as Parameters<typeof StoryblokRichText>[0]['doc']}
        />
      )}
    </SiteContainer>
  </article>
);
